import { Group, Text, Tooltip } from '@mantine/core';

import { SvgBigInfo } from '@/components/Dashboard/icon';

interface CustomContainerHeaderProps {
  title: string;
  label: string;

  rightSection?: React.ReactNode;
}

const CustomContainerHeader: React.FC<CustomContainerHeaderProps> = ({ label, rightSection, title }) => {
  return (
    <Group justify="space-between" mt={10} mb={30}>
      <Tooltip label={label} position="right">
        <Group gap={'sm'}>
          <Text size={'xl'}>{title}</Text>
          <SvgBigInfo />
        </Group>
      </Tooltip>

      {rightSection}
    </Group>
  );
};

export default CustomContainerHeader;
